import React, { useEffect, useMemo } from "react";
import Section from "../sections/Section";
import arePropsEqual from "../../utils/arePropsEqual";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
import { normalizeObjectsPositions } from "../../utils/builderUtils.js";
import {
  getPreviewConfig,
  buildCarouselStylesheet,
} from "./ElementCarouselStyleResolver";
import BuilderStyleTag from "../shared/BuilderStyleTag";
library.add(fab, fas, far);

const ElementCarousel = (props) => {
  let element = props.element;
  const swipeType = element.options["carousel-swipe-type"];

  const previewConfig = getPreviewConfig(element, props.device);
  const showPreview = previewConfig.enabled;

  const classes = style.classes(element, props.builder, props.device);

  let sorted_carousel_items = Object.values(element.content_toggle_items)
    .filter(
      (tab_item) =>
        tab_item.element_id == element.id && tab_item.toBeDeleted !== true
    )
    .sort((a, b) => a.position - b.position);

  const stylesheet = buildCarouselStylesheet(
    props.builder,
    props.device,
    props.cta,
    element,
    props.variant
  );

  const useInfiniteLoopIndicators =
    swipeType !== "scrolling" &&
    element.options["carousel-sliding-style"] === "infinite_loop" &&
    sorted_carousel_items.length > 1;

  let getCurrentPosition = () => {
    let indicators = document.querySelectorAll(
      `#builder .cf-element[data-element-id="${element.id}"] .cf-carousel-indicator`
    );

    return (
      [...indicators].findIndex((item) =>
        item.classList.contains("active")
      ) + 1
    );
  };

  const updateIndicatorPositionTo = (target_position) => {
    if (target_position > sorted_carousel_items.length) {
      target_position = 1;
    } else if (target_position <= 0) {
      target_position = sorted_carousel_items.length;
    }

    $(`div[data-element-id="${element.id}"]`).attr(
      "data-slide-page",
      target_position
    );

    if (element.options["carousel-hide-indicator-controls"] !== "true") {
      let indicator = `#builder .cf-element[data-element-id="${element.id}"] .cf-carousel-indicator`;
      const indicators = Array.from(document.querySelectorAll(indicator));

      if (useInfiniteLoopIndicators && indicators.length > 0) {
        const previousPosition = target_position === 1
          ? sorted_carousel_items.length
          : target_position - 1;
        const nextPosition = target_position === sorted_carousel_items.length
          ? 1
          : target_position + 1;
        const indicatorPositions = [previousPosition, target_position, nextPosition];

        indicators.forEach((indicatorElement, index) => {
          if (index < 3) {
            indicatorElement.style.display = "block";
            indicatorElement.setAttribute("data-position", indicatorPositions[index]);
            indicatorElement.classList.toggle("active", index === 1);
          } else {
            indicatorElement.style.display = "none";
            indicatorElement.classList.remove("active");
          }
        });

        return;
      }

      $(indicator).removeClass("active");
      $(`${indicator}[data-position="${target_position}"]`).addClass("active");
    }
  };

  const carouselIndicators = useMemo(() => {
    if (swipeType === "scrolling") {
      return;
    }

    const indicatorItems = useInfiniteLoopIndicators
      ? [
        { key: "previous", position: sorted_carousel_items.length, active: false },
        { key: "current", position: 1, active: true },
        { key: "next", position: sorted_carousel_items.length > 1 ? 2 : 1, active: false },
      ]
      : normalizeObjectsPositions(sorted_carousel_items).map((carousel) => ({
        key: carousel.position,
        position: carousel.position,
        active: false,
      }));

    return (
      <React.Fragment>
        <div className="cf-carousel-indicators">
          {element.options["carousel-hide-indicator-controls"] !== "true" &&
            indicatorItems.map((indicatorItem) => {
              return (
                <div
                  key={`cf-carousel-${element.id}-${indicatorItem.key}`}
                  className={`cf-indicator-go-to cf-carousel-indicator ${indicatorItem.active ? "active" : ""}`}
                  data-position={indicatorItem.position}
                ></div>
              );
            })}
        </div>
      </React.Fragment>
    );
  }, [sorted_carousel_items.length, swipeType, useInfiniteLoopIndicators, element.options["carousel-hide-indicator-controls"]]);

  const carouselSlides = () => {
    return (
      <React.Fragment>
        <div
          className="cf-carousel"
          style={
            swipeType === "scrolling"
              ? { justifyContent: "flex-start", transform: "none" }
              : {}
          }
        >
          {/* START DYNAMIC ITEMS LOADING */}
          {sorted_carousel_items.map((carousel) => {
            let carousel_item_section = Object.values(element.sections).filter(
              (section) =>
                section.content_toggle_item_id == carousel.id &&
                section.step_id == props.section.step_id
            )[0];

            return (
              <div
                key={`cf-carousel-item-${carousel.id}`}
                className={"cf-carousel-item"}
                data-toggle-item-id={carousel.id}
              >
                {carousel_item_section ? (
                  <Section
                    key={`cf-carousel-section-item-${carousel.id}`}
                    website={props.website}
                    cta={props.cta}
                    variant={props.variant}
                    builder={props.builder}
                    preview={props.preview}
                    step={props.step}
                    section={carousel_item_section}
                    device={props.device}
                  ></Section>
                ) : (
                  ""
                )}
              </div>
            );
          })}
          {/* END DYNAMIC ITEMS LOADING */}
        </div>
      </React.Fragment>
    );
  };

  const carouselLeftArrow = (location) => {
    if (swipeType === "scrolling") {
      return;
    }

    return (
      <React.Fragment>
        {props.element.options["carousel-hide-arrow-controls"] !== "true" &&
        carouselControlsStyle == location ? (
          <div
            className={`cf-arrow-control cf-arrow-left ${
              props.builder == true ? "editing" : ""
            }`}
          >
            <FontAwesomeIcon icon="angle-left" />
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  };

  const carouselRightArrow = (location) => {
    if (swipeType === "scrolling") {
      return;
    }

    return (
      <React.Fragment>
        {props.element.options["carousel-hide-arrow-controls"] !== "true" &&
        carouselControlsStyle == location ? (
          <div
            className={`cf-arrow-control cf-arrow-right ${
              props.builder == true ? "editing" : ""
            }`}
          >
            <FontAwesomeIcon icon="angle-right" />
          </div>
        ) : (
          ""
        )}
      </React.Fragment>
    );
  };

  useEffect(() => {
    const element_div = `#builder .cf-carousel-element[data-element-id="${element.id}"]`;
    const carousel_wrapper = document.querySelector(`${element_div} .cf-carousel-wrapper`);
    if (!carousel_wrapper) {
      return;
    }

    const sliderNode = carousel_wrapper.querySelector(".cf-carousel");
    if (!sliderNode) {
      return;
    }

    if (swipeType === "scrolling") {
      return;
    }

    const EL_slider = $(sliderNode);
    const rawSlidesPerView = parseInt(carousel_wrapper.dataset.items, 10);
    const sub = Number.isNaN(rawSlidesPerView) || rawSlidesPerView < 1 ? 1 : rawSlidesPerView;
    const useInfiniteLoop = element.options["carousel-sliding-style"] === "infinite_loop";
    let loopEdgeCloneCount = 0;
    let c = 0;
    let currentTargetPosition = 1;
    let sliderTransitionHandler = null;

    const previewConfig = getPreviewConfig(element, props.device);
    const { enabled: showPreview, previewWidth, mainWidth } = previewConfig;
    const totalSlides = sorted_carousel_items.length;

    const slideWidthPercent = showPreview ? mainWidth : 100;
    const ratioPerSlide = () => parseFloat(((slideWidthPercent / sub) * 0.01).toFixed(5));
    const canUseInfiniteLoop = useInfiniteLoop && totalSlides > 1;

    const carouselPagesMatrix = (targetPosition) => {
      let positionPageMatrix = {};
      let slidesPerView = sub;
      let totalPages = Math.ceil(carousel_wrapper.querySelectorAll(".cf-carousel-item").length / sub);
      let slidePositionCounter = 1;
      let ratioCounter = 0;

      Array.from({ length: totalPages }).forEach((_x) => {
        Array.from({ length: slidesPerView }).forEach((_x) => {
          positionPageMatrix[slidePositionCounter] = ratioCounter;
          slidePositionCounter += 1;
          ratioCounter += ratioPerSlide();
        });
      });

      if (targetPosition) {
        return positionPageMatrix[targetPosition];
      } else {
        return positionPageMatrix;
      }
    };

    carousel_wrapper.querySelectorAll(".cf-carousel-clone").forEach((clone) => clone.remove());

    if (canUseInfiniteLoop) {
      const realItems = Array.from(carousel_wrapper.querySelectorAll(".cf-carousel-item"));
      loopEdgeCloneCount = Math.min(sub, realItems.length);

      const firstSlides = realItems.slice(0, loopEdgeCloneCount);
      const lastSlides = realItems.slice(-loopEdgeCloneCount);

      lastSlides.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.classList.add("cf-carousel-clone");
        sliderNode.insertBefore(clone, sliderNode.firstChild);
      });

      firstSlides.forEach((item) => {
        const clone = item.cloneNode(true);
        clone.classList.add("cf-carousel-clone");
        sliderNode.appendChild(clone);
      });

      currentTargetPosition = loopEdgeCloneCount + 1;
    }

    const normalizeTargetPosition = (target_position) => {
      if (totalSlides <= 0) {
        return 1;
      }

      let parsedTargetPosition = parseInt(target_position, 10);
      if (Number.isNaN(parsedTargetPosition)) {
        parsedTargetPosition = 1;
      }

      if (parsedTargetPosition > totalSlides) {
        return 1;
      }

      if (parsedTargetPosition < 1) {
        return totalSlides;
      }

      return parsedTargetPosition;
    };

    const logicalPositionFromRendered = (target_position) => {
      if (!canUseInfiniteLoop) {
        return normalizeTargetPosition(target_position);
      }

      let logicalTargetPosition = parseInt(target_position, 10) - loopEdgeCloneCount;

      while (logicalTargetPosition < 1) {
        logicalTargetPosition += totalSlides;
      }

      while (logicalTargetPosition > totalSlides) {
        logicalTargetPosition -= totalSlides;
      }

      return logicalTargetPosition;
    };

    const renderedPositionFromLogical = (target_position) => {
      const normalizedTargetPosition = normalizeTargetPosition(target_position);
      return canUseInfiniteLoop
        ? normalizedTargetPosition + loopEdgeCloneCount
        : normalizedTargetPosition;
    };

    const normalizeRenderedTargetPosition = (target_position) => {
      let parsedTargetPosition = parseInt(target_position, 10);

      if (Number.isNaN(parsedTargetPosition)) {
        return loopEdgeCloneCount + 1;
      }

      if (!canUseInfiniteLoop) {
        return normalizeTargetPosition(parsedTargetPosition);
      }

      const minRenderedPosition = loopEdgeCloneCount;
      const maxRenderedPosition = loopEdgeCloneCount + totalSlides + 1;

      while (parsedTargetPosition < minRenderedPosition) {
        parsedTargetPosition += totalSlides;
      }

      while (parsedTargetPosition > maxRenderedPosition) {
        parsedTargetPosition -= totalSlides;
      }

      return parsedTargetPosition;
    };

    const anim = () => {
      const isLastSlide = currentTargetPosition === totalSlides;
      if (!canUseInfiniteLoop && showPreview && isLastSlide && totalSlides > 1) {
        const offset = c * 100 - previewWidth;
        EL_slider.css("transform", `translateX(-${offset}%)`);
      } else {
        let offset = c * 100;
        EL_slider.css("transform", `translateX(-${offset}%)`);
      }
    };

    const resetInfiniteLoopPosition = () => {
      if (!canUseInfiniteLoop) {
        return;
      }

      const firstRealPosition = loopEdgeCloneCount + 1;
      const lastRealPosition = firstRealPosition + totalSlides - 1;

      if (
        currentTargetPosition < firstRealPosition ||
        currentTargetPosition > lastRealPosition
      ) {
        while (currentTargetPosition < firstRealPosition) {
          currentTargetPosition += totalSlides;
        }

        while (currentTargetPosition > lastRealPosition) {
          currentTargetPosition -= totalSlides;
        }

        c = carouselPagesMatrix(currentTargetPosition);
        EL_slider.css("transition", "none");
        anim();

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            EL_slider.css("transition", "");
          });
        });
      }
    };

    if (canUseInfiniteLoop) {
      sliderTransitionHandler = (event) => {
        if (event.target !== sliderNode || event.propertyName !== "transform") {
          return;
        }

        resetInfiniteLoopPosition();
      };

      sliderNode.addEventListener("transitionend", sliderTransitionHandler);
    }

    const goToPage = (target_position, target_id, options = {}) => {
      const { renderedPosition = false } = options;
      const renderedTargetPosition = renderedPosition
        ? normalizeRenderedTargetPosition(target_position)
        : null;
      const indicatorPosition = renderedPosition
        ? logicalPositionFromRendered(renderedTargetPosition)
        : normalizeTargetPosition(target_position);

      updateIndicatorPositionTo(indicatorPosition);
      currentTargetPosition = renderedPosition
        ? renderedTargetPosition
        : renderedPositionFromLogical(indicatorPosition);

      if (target_id) {
        dispatchCustomEvent("focusItem", {
          parent_id: element.id,
          item_type: "content_toggle_items",
          item_id: target_id,
          triggerPanelVisibility: false,
        });
      }

      c = carouselPagesMatrix(currentTargetPosition);
      anim();
    };

    const totalNonEmptySlides = () => {
      return Math.max((totalSlides - sub) + 1, 1);
    };

    const prev = () => {
      if (canUseInfiniteLoop) {
        goToPage(currentTargetPosition - 1, null, { renderedPosition: true });
        return;
      }

      const elementTag = document.querySelector(element_div);
      let currentPage = normalizeTargetPosition(elementTag?.getAttribute("data-slide-page") || 1);

      if (currentPage === 1) {
        currentPage = totalNonEmptySlides();
      } else {
        currentPage -= 1;
      }

      goToPage(currentPage);
    };

    const next = () => {
      if (canUseInfiniteLoop) {
        goToPage(currentTargetPosition + 1, null, { renderedPosition: true });
        return;
      }

      const elementTag = document.querySelector(element_div);
      let currentPage = normalizeTargetPosition(elementTag?.getAttribute("data-slide-page") || 1);

      if (currentPage === totalNonEmptySlides()) {
        currentPage = 1;
      } else {
        currentPage += 1;
      }

      goToPage(currentPage);
    };

    const arrowControlBindings = [];
    if (element.options["carousel-hide-arrow-controls"] !== "true") {
      const stopArrowEvent = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === "function") {
          event.stopImmediatePropagation();
        }
      };

      const bindArrowControls = (selector, callback) => {
        carousel_wrapper.querySelectorAll(selector).forEach((arrowControl) => {
          const onArrowMouseDown = (event) => {
            stopArrowEvent(event);
          };
          const onArrowTouchStart = (event) => {
            stopArrowEvent(event);
          };
          const onArrowClick = (event) => {
            stopArrowEvent(event);
            callback();
          };

          arrowControl.addEventListener("mousedown", onArrowMouseDown);
          arrowControl.addEventListener("touchstart", onArrowTouchStart, { passive: false });
          arrowControl.addEventListener("click", onArrowClick);

          arrowControlBindings.push(() => {
            arrowControl.removeEventListener("mousedown", onArrowMouseDown);
            arrowControl.removeEventListener("touchstart", onArrowTouchStart);
            arrowControl.removeEventListener("click", onArrowClick);
          });
        });
      };

      bindArrowControls(".cf-arrow-left", prev);
      bindArrowControls(".cf-arrow-right", next);
    }

    const handleGoToPage = (e) => {
      const toggle_item = e.detail.toggle_item;

      goToPage(toggle_item.position, toggle_item.id);
    };

    const eventName = `cf_element_${element.id}_select_toggle_item`;
    document.addEventListener(eventName, handleGoToPage);

    if (canUseInfiniteLoop) {
      EL_slider.css("transition", "none");
      goToPage(getCurrentPosition() || 1);

      requestAnimationFrame(() => {
        EL_slider.css("transition", "");
      });
    } else {
      // Fix position when changing number of slides per view
      goToPage(getCurrentPosition() || 1);
    }

    return () => {
      document.removeEventListener(eventName, handleGoToPage);
      if (sliderTransitionHandler) {
        sliderNode.removeEventListener("transitionend", sliderTransitionHandler);
      }
      arrowControlBindings.forEach((unbindArrowControl) => unbindArrowControl());
      carousel_wrapper.querySelectorAll(".cf-carousel-clone").forEach((clone) => clone.remove());
      EL_slider.css("transition", "");
    };
  }, [
    props.device,
    sorted_carousel_items.length,
    element.options["carousel-swipe-type"],
    element.options["carousel-sliding-style"],
    element.options["carousel-slides-per-view"],
    element.options["carousel-slides-per-view-mobile"],
    element.options["show-next-slide-preview"],
    element.options["show-next-slide-preview-mobile"],
    element.options["carousel-next-preview-percentage"],
    element.options["carousel-next-preview-percentage-mobile"],
    element.options["carousel-preview-width"],
    element.options["carousel-preview-width-mobile"],
    element.options["carousel-hide-arrow-controls"],
    element.options["carousel-hide-indicator-controls"],
    element.options["carousel-controls-style"],
  ]);

  let carouselControlsStyle =
    element.options["carousel-controls-style"] ||
    props.variant.options["carousel-controls-style"] ||
    "inside";

  return (
    <React.Fragment>
      <div className={classes} data-element-id={element.id} data-slide-page="1">
        <div
          className="cf-carousel-wrapper"
          data-items={
            (props.builder == true
              ? props.device == "desktop"
                ? element.options["carousel-slides-per-view"]
                : element.options["carousel-slides-per-view-mobile"]
              : 1) || 1
          }
        >
          {carouselLeftArrow("outside")}

          <div className="cf-carousel-slide-wrapper">
            {carouselLeftArrow("inside")}

            <div
              className="cf-carousel-slide-inside-wrapper"
              style={{
                overflow: swipeType === "scrolling" ? "auto" : "hidden",
                flex: "1",
              }}
            >
              {carouselSlides()}
            </div>

            {carouselRightArrow("inside")}
          </div>

          {carouselRightArrow("outside")}
        </div>

        {carouselIndicators}

        <BuilderStyleTag
          builder={props.builder}
          styleKey={`cta:${props.cta.id}:element:${element.id}:carousel`}
          stylesheet={stylesheet}
        />
      </div>
    </React.Fragment>
  );
};

const style = {
  classes: (element, builder, device) => {
    let options = element.options;
    let classes = "element-content cf-carousel-element ";
    let alignmentClass = "cf-outer-center";

    if (device == "mobile") {
      if (options["cf-alignment-mobile"]) {
        if (options["cf-alignment-mobile"].indexOf("left") > -1) {
          alignmentClass = "cf-outer-left";
        } else if (options["cf-alignment-mobile"].indexOf("center") > -1) {
          alignmentClass = "cf-outer-center";
        } else if (options["cf-alignment-mobile"].indexOf("right") > -1) {
          alignmentClass = "cf-outer-right";
        }
      }
    } else {
      if (options["cf-alignment"]) {
        if (options["cf-alignment"].indexOf("left") > -1) {
          alignmentClass = "cf-outer-left";
        } else if (options["cf-alignment"].indexOf("center") > -1) {
          alignmentClass = "cf-outer-center";
        } else if (options["cf-alignment"].indexOf("right") > -1) {
          alignmentClass = "cf-outer-right";
        }
      }
    }

    classes += " " + alignmentClass;

    return classes;
  },
};

export default React.memo(ElementCarousel, arePropsEqual);
